export const PRIMARY_COLOR = "#1976d2";
